import { type FunctionComponent, useState } from 'react';

import { Link, WithTooltip } from '@dr.pogodin/react-utils';

import Status from 'components/Status';
import AdminPractitionerLink from 'components/admin/PractitionerLink';

import RemovePractitionerModal from 'components/admin/RemovePractitionerModal';
import { type ArtistT, P_ADMIN_PRACTITIONERS, getId } from 'utils';

import IconEdit from 'assets/images/icon-edit-16px.svg';

import IconTrash from 'assets/images/icon-trash-16px.svg';

import './style.scss';

type PropsT = {
  artist: ArtistT;
  onRemove: () => Promise<void>;
};

const Item: FunctionComponent<PropsT> = ({ artist, onRemove }) => {
  const artistId = getId(artist);

  const practitionerPageUrl = `${P_ADMIN_PRACTITIONERS}/${artistId}`;

  const [showRemoveModal, setShowRemoveModal] = useState(false);

  return (
    <tr>
      <td><AdminPractitionerLink practitioner={artist} /></td>
      <td data-label="Practitioners ID" styleName="artistId">{artist.id}</td>
      <td data-label="Modalities" styleName="specialization">{artist.specialization}</td>
      <td data-label="Status"><Status status={artist.status} /></td>
      <td aria-label="Actions" styleName="bottom">
        <div styleName="icons">
          <WithTooltip tip="Edit Practitioner">
            <Link to={practitionerPageUrl}>
              <IconEdit />
            </Link>
          </WithTooltip>
          <WithTooltip tip="Delete Practitioner">
            <Link
              onClick={() => {
                setShowRemoveModal(true);
              }}
              to=""
            >
              <IconTrash />
            </Link>
          </WithTooltip>
        </div>
        {showRemoveModal ? (
          <RemovePractitionerModal
            onCancel={() => {
              setShowRemoveModal(false);
            }}
            onRemove={onRemove}
          />
        ) : null}
      </td>
    </tr>
  );
};

export default Item;
